import { Close, CloudUpload, Delete, Send } from "@mui/icons-material";
import {
    Avatar,
    Button,
    CircularProgress,
    FormControl,
    Grid,
    IconButton,
    InputLabel,
    ListItemAvatar,
    MenuItem,
    Select,
    TextareaAutosize,
    TextField,
    Typography,
} from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import styled from "styled-components";
import {
    GetAllDepartments,
    GetUserByRole,
    messagesReset,
    SendMessageMethod,
} from "../../Redux/MessagesSlice/MessagesSlice";
import uploadImage from "../../Assets/images/uploadImage.png";

function MessagesCompose({ closeCompose }) {
    const dispatch = useDispatch();

    const { pusher_data } = useSelector((state) => state.pusher);
    const [Files, setFiles] = useState({
        type: "",
        path: "",
    });
    const PusherData = pusher_data || [];

    // useEffect(() => {
    //     if (PusherData)
    //     {

    //     }
    // }, [PusherData])

    const { mainUser } = useSelector((state) => state.auth);
    const user_id = mainUser?.data.id || 0;

    const { departments, userRole, isSuccess, isError, isLoading, errors } =
        useSelector((state) => state.messages);

    const AllDepartments = departments?.data || [];
    const crmMembers = userRole?.data?.crm?.users || [];
    const installersMembers = userRole?.data?.installer?.users || [];
    const DepartmentTitle = userRole?.data?.department || [];
    const pmMembers = userRole?.data?.pm?.users || [];
    const formik = useFormik({
        initialValues: {
            department_id_sender: 2,
            site_sender: "crm",
            user_receiver: "",
            site_receiver: "",
            department_id_receiver: "",
            body: "",
            file_path: "",
        },
        onSubmit: async (values) => {
            const formData = new FormData();
            formData.append("user_sender", user_id);
            formData.append(
                "department_id_sender",
                formik.values.department_id_sender
            );
            formData.append("site_sender", formik.values.site_sender);
            formData.append("user_receiver", formik.values.user_receiver);
            formData.append("site_receiver", formik.values.site_receiver);
            formData.append(
                "department_id_receiver",
                formik.values.department_id_receiver
            );
            formData.append("body", formik.values.body);
            formData.append("file_path", formik.values.file_path);
            await dispatch(SendMessageMethod(formData));
            await dispatch(messagesReset());
        },
    });

    useEffect(() => {
        formik.values.department_id_sender = 2;
        formik.values.site_sender = "crm";
        formik.values.user_receiver = "";
        formik.values.site_receiver = "";
        formik.values.department_id_receiver = "";
        formik.values.body = "";
        formik.values.file_path = "";
    }, []);

    useEffect(() => {
        const CallGetAllDepartments = async () => {
            await dispatch(GetAllDepartments());
            await dispatch(messagesReset());
        };
        CallGetAllDepartments();
    }, [dispatch]);

    // Handel Remove File From Compose
    const handelRemoveFormFile = () => {
        formik.values.file_path = "";
        let fileContainer = document.getElementById("file-show-container");
        if (fileContainer) {
            fileContainer.innerHTML = "";
        }
    };

    const handleChangeImage2 = (e) => {
        let extension = e.currentTarget.files[0].name.split(".").pop();
        let image_type = ["jpg", "png", "svg", "webp"];
        let file_types = ["pdf"];
        let src = URL.createObjectURL(e.currentTarget.files[0]);
        let fileContainer = document.getElementById("file-show-container");
        formik.values.file_path = e.currentTarget.files[0];
        if (image_type.includes(extension)) {
            
            let image = `<img
                            class="file-path-show"
                            src="${src}"
                            alt=""
                        />`;
            fileContainer.innerHTML = image;
        } else if (file_types.includes(extension)) {
            let pdf = `<embed
                            src="${src}"
                            width="400"
                            class="file-path-show"
                            height="400"
                            ></embed> `;
            fileContainer.innerHTML = pdf;
        } else {
            fileContainer.innerHTML = `${e.currentTarget.files[0].name}`;
        }
    };

    const handleChangeImage = (e) => {
        formik.values.file_path = e.currentTarget.files[0];
        let src = URL.createObjectURL(e.currentTarget.files[0]);
        let extension = e.currentTarget.files[0].name.split(".").pop();
        setFiles({
            type: extension,
            path: src,
        });
    };

    const handelRemoveFile = () => {
        formik.values.file_path = ""
        setFiles({
            type: "",
            path: "",
        });
    };

    useEffect(() => {
        if (isError) {
            if (errors.length !== 0 && errors) {
                Object.keys(errors).forEach((key) => {
                    let error = errors[key][0];
                    toast.error(error);
                });
            } else {
                toast.error("You Must Enter Message Or Upload File");
            }
            const reset = async () => {
                await dispatch(messagesReset());
            };
            reset();
        }
    }, [isError, errors, dispatch]);

    useEffect(() => {
        if (formik.values.department_id_receiver) {
            AllDepartments.map((dep, index) => {
                if (dep.id == formik.values.department_id_receiver) {
                    formik.values.site_receiver = dep.title;
                }
            });
            const CallDepartmentMethod = async () => {
                await dispatch(
                    GetUserByRole({
                        id: formik.values.department_id_receiver,
                        title: formik.values.site_receiver,
                    })
                );
                await dispatch(messagesReset());
            };
            CallDepartmentMethod();
        }
    }, [formik.values.department_id_receiver]);

    const [UserReceiverId, setUserReceiverId] = useState("");

    const handelChangeCRMmember = (e) => {
        formik.values.user_receiver = e.target.value;
        formik.values.site_receiver = "crm";
        setUserReceiverId(e.target.value);
    };

    const handelChangeINSTALLERmember = (e) => {
        formik.values.user_receiver = e.target.value;
        formik.values.site_receiver = "installer";
        setUserReceiverId(e.target.value);
    };

    const handelChangePMmember = (e) => {
        formik.values.user_receiver = e.target.value;
        formik.values.site_receiver = "pm";
        setUserReceiverId(e.target.value);
    };

    useEffect(() => {
        if (
            isSuccess &&
            formik.values.body.length !== 0 &&
            formik.values.site_sender.length !== 0
        ) {
            toast.success("Message sent successfully");
            formik.values.department_id_sender = 2;
            formik.values.site_sender = "crm";
            formik.values.user_receiver = "";
            formik.values.site_receiver = "";
            formik.values.department_id_receiver = "";
            formik.values.body = "";
        }
    }, [isSuccess]);

    return (
        <>
            <MessagesComposeB>
                <div className="compose-box">
                    {isLoading && (
                        <LoadingBox className="loading">
                            <CircularProgress />
                        </LoadingBox>
                    )}
                    {!isLoading && (
                        <form onSubmit={formik.handleSubmit}>
                            <IconButton
                                onClick={() => closeCompose()}
                                sx={{ float: "right" }}
                            >
                                <Close />
                            </IconButton>

                            <Typography
                                variant="h5"
                                sx={{ fontWeight: "700", padding: "15px" }}
                                align="center"
                                color="black"
                            >
                                Send Message to Department
                            </Typography>
                            <hr></hr>
                            <Grid container coulmns={12} mt={3}>
                                <Grid item mb={1} xs={12} md={12} mt={3}>
                                    <FormControl fullWidth required={true}>
                                        <InputLabel id="demo-simple-select-label">
                                            Department
                                        </InputLabel>
                                        <Select
                                            id="department_id_receiver"
                                            name="department_id_receiver"
                                            label="Department"
                                            required={true}
                                            value={
                                                formik.values
                                                    .department_id_receiver ||
                                                ""
                                            }
                                            onChange={formik.handleChange}
                                        >
                                            {AllDepartments?.map(
                                                (key, index) => (
                                                    <MenuItem
                                                        key={index}
                                                        value={key.id}
                                                        data="teas"
                                                    >
                                                        {key.title.toUpperCase()}
                                                    </MenuItem>
                                                )
                                            )}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                {formik.values.department_id_receiver &&
                                    crmMembers &&
                                    crmMembers?.length !== 0 && (
                                        <Grid
                                            item
                                            mb={1}
                                            xs={12}
                                            md={12}
                                            mt={3}
                                        >
                                            <FormControl fullWidth>
                                                <InputLabel id="demo-simple-select-label">
                                                    CRM Members
                                                </InputLabel>
                                                <Select
                                                    id="user_receiver"
                                                    name="user_receiver"
                                                    label="CRM Members"
                                                    value={UserReceiverId}
                                                    onChange={(e) =>
                                                        handelChangeCRMmember(e)
                                                    }
                                                >
                                                    {crmMembers?.map(
                                                        (key, index) => (
                                                            <MenuItem
                                                                key={index}
                                                                value={key.id}
                                                            >
                                                                {key.name +
                                                                    " " +
                                                                    key.email}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    )}

                                {formik.values.department_id_receiver &&
                                    installersMembers &&
                                    installersMembers?.length !== 0 && (
                                        <Grid
                                            item
                                            mb={1}
                                            xs={12}
                                            md={12}
                                            mt={3}
                                        >
                                            <FormControl fullWidth>
                                                <InputLabel id="demo-simple-select-label">
                                                    Installers
                                                </InputLabel>
                                                <Select
                                                    id="user_receiver"
                                                    name="user_receiver"
                                                    label="CRM Users"
                                                    value={UserReceiverId}
                                                    onChange={(e) =>
                                                        handelChangeINSTALLERmember(
                                                            e
                                                        )
                                                    }
                                                >
                                                    {installersMembers?.map(
                                                        (key, index) => (
                                                            <MenuItem
                                                                key={index}
                                                                value={key.id}
                                                            >
                                                                {key.name +
                                                                    " " +
                                                                    key.email}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    )}

                                {formik.values.department_id_receiver &&
                                    pmMembers &&
                                    pmMembers?.length !== 0 && (
                                        <Grid
                                            item
                                            mb={1}
                                            xs={12}
                                            md={12}
                                            mt={3}
                                        >
                                            <FormControl fullWidth>
                                                <InputLabel id="demo-simple-select-label">
                                                    PM Members
                                                </InputLabel>
                                                <Select
                                                    id="user_receiver"
                                                    name="user_receiver"
                                                    label="PM Members"
                                                    value={UserReceiverId}
                                                    onChange={(e) =>
                                                        handelChangePMmember(e)
                                                    }
                                                >
                                                    {pmMembers?.map(
                                                        (key, index) => (
                                                            <MenuItem
                                                                key={index}
                                                                value={key.id}
                                                            >
                                                                {key.name +
                                                                    " " +
                                                                    key.email}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    )}
                                {/* <Grid item mb={1} xs={12} md={12} mt={3}>
                                    <TextField
                                        fullWidth
                                        height={250}
                                        id="body"
                                        name="body"
                                        label="Enter Your Message ... "
                                        value={formik.values.body || ""}
                                        onChange={formik.handleChange}
                                        error={
                                            formik.touched.body &&
                                            Boolean(formik.errors.body)
                                        }
                                        helperText={
                                            formik.touched.body &&
                                            formik.errors.body
                                        }
                                    />
                                </Grid> */}
                                <Grid item mb={1} xs={12} md={12} mt={3}>
                                    <TextareaAutosize
                                        aria-label="minimum height"
                                        minRows={3}
                                        id="body"
                                        name="body"
                                        placeholder="Enter Your Message ..."
                                        label="Enter Your Message ... "
                                        value={formik.values.body || ""}
                                        onChange={formik.handleChange}
                                        style={{
                                            width: "100%",
                                            height: "300px",
                                            padding: "15px",
                                            fontSize: "1.5em",
                                            border: "2px solid #1976d2",
                                        }}
                                    />
                                </Grid>

                                <Grid
                                    id="file-show-container"
                                    item
                                    mb={1}
                                    xs={12}
                                    md={12}
                                    sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                    }}
                                >
                                    {["jpg", "png", "svg"].includes(
                                        Files.type
                                    ) && (
                                        <div
                                            sx={{
                                                display: "flex",
                                                justifyContent: "center",
                                            }}
                                            id="message-file-preview"
                                        >
                                            <div id="delete-file-btn">
                                                <Button
                                                    color="error"
                                                    onClick={() => {
                                                        handelRemoveFile();
                                                    }}
                                                >
                                                    <Close />
                                                </Button>
                                            </div>
                                            <img
                                                className="file-path-show"
                                                src={Files.path}
                                                alt=""
                                            />
                                        </div>
                                    )}

                                    {Files.type === "pdf" && (
                                        <div
                                            sx={{
                                                display: "flex",
                                                justifyContent: "center",
                                            }}
                                            id="message-file-preview"
                                        >
                                            <div id="delete-file-btn">
                                                <Button
                                                    color="error"
                                                    onClick={() => {
                                                        handelRemoveFile();
                                                    }}
                                                >
                                                    <Close />
                                                </Button>
                                            </div>
                                            <embed
                                                src={Files.path}
                                                width="400"
                                                class="file-path-show"
                                                height="400"
                                            ></embed>
                                        </div>
                                    )}
                                </Grid>

                                <Grid item mb={1} xs={12} md={12}>
                                    <Button
                                        className="upload-image-btn"
                                        mt={3}
                                        mr={2}
                                        ml={2}
                                        fullWidth
                                        variant="contained"
                                        component="label"
                                    >
                                        <CloudUpload />
                                        <span mr={2} ml={2}>
                                            Send File
                                        </span>
                                        <input
                                            hidden
                                            type="file"
                                            name="file_path"
                                            id="file_path"
                                            onChange={(e) =>
                                                handleChangeImage(e)
                                            }
                                        />
                                    </Button>
                                </Grid>

                                <Grid
                                    item
                                    mb={1}
                                    xs={12}
                                    md={12}
                                    mt={3}
                                    className="button-send-message"
                                >
                                    <Button
                                        endIcon={<Send />}
                                        variant="contained"
                                        type="submit"
                                        fullWidth
                                        sx={{ padding: "10px" }}
                                    >
                                        Send Message
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                    )}
                </div>
            </MessagesComposeB>
        </>
    );
}
const LoadingBox = styled.div`
    display: flex;
    position: relative;
    height: 100%;
    span {
        position: fixed;
        right: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
`;
const MessagesComposeB = styled.div`
    position: fixed;
    width: 100%;
    height: 100%;
    background: #0000001f;
    z-index: 999;
    left: 0;
    top: 0;
    .compose-box {
        max-height: 90%;
        overflow: auto;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        background: #fff;
        min-width: 50%;
        min-height: 50%;
        border-radius: 15px;
        box-shadow: 2px 3px 10px #1976d2;
        padding: 10px;
    }
    textarea {
        width: "100%",
        height: "300px",
        padding: "15px",
        fontSize: "1.5em",
        border: "2px solid #1976d2"
    }
    .button-send-message svg , .upload-image-btn svg{
        color: #fff;
    }
    .upload-image-btn svg{
        margin:  0 7px;
    }
    .file-path-show {
        width: 300px;
        height: 300px;
        border-radius: 10px;
        box-shadow: -1px 1px 13px;
    }
    
`;
export default MessagesCompose;
